(function () {
  var SELECTOR = '.wd-promo-trio__card, .wd-quiz-hero__frame, .wd-nav-strip__link, .wd-cat-card, .wd-promo-tile, .wd-duo-feature__card, .wd-theme-cols__hero, .wd-occasion';

  function wdRoutesRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function wdStoreUrl(path) {
    var p = String(path || '').replace(/^\//, '');
    return wdRoutesRoot() + p;
  }

  function bindPress(el) {
    el.addEventListener(
      'pointerdown',
      function () {
        el.classList.add('is-pressed');
      },
      { passive: true }
    );

    function clear() {
      el.classList.remove('is-pressed');
    }

    el.addEventListener('pointerup', clear, { passive: true });
    el.addEventListener('pointercancel', clear, { passive: true });
    el.addEventListener('pointerleave', clear, { passive: true });
  }

  function bindBottleFallback(el) {
    if (el.__wdBottleFallback) return;
    el.__wdBottleFallback = true;
    el.addEventListener('error', function () {
      var fb = el.getAttribute('data-fallback');
      if (fb && el.src !== fb) el.src = fb;
    });
  }

  /* Align bottle silhouettes: same baseline + similar visual height */
  function alignBottleImage(img) {
    if (!img || img.__wdAligned || img.tagName !== 'IMG') return;
    if (img.getAttribute('data-wd-align') !== 'bottle') return;

    function measureAndApply() {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      if (!nw || !nh) return;

      var maxW = 160;
      var scale = maxW / nw;
      var cw = maxW;
      var ch = Math.max(1, Math.round(nh * scale));
      var canvas = document.createElement('canvas');
      canvas.width = cw;
      canvas.height = ch;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return;

      try {
        ctx.drawImage(img, 0, 0, cw, ch);
        var data = ctx.getImageData(0, 0, cw, ch).data;
      } catch (err) {
        /* CORS — keep CSS baseline only */
        return;
      }

      var minY = ch;
      var maxY = -1;
      var y;
      var x;
      var i;
      var r;
      var g;
      var b;
      var a;
      for (y = 0; y < ch; y++) {
        for (x = 0; x < cw; x++) {
          i = (y * cw + x) * 4;
          a = data[i + 3];
          if (a < 24) continue;
          r = data[i];
          g = data[i + 1];
          b = data[i + 2];
          if (r >= 246 && g >= 246 && b >= 246) continue;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }

      if (maxY < minY) return;

      var contentH = (maxY - minY + 1) / ch;
      var padBottom = 1 - (maxY + 1) / ch;
      if (contentH < 0.08) return;

      /* Target bottle ≈ 90% of frame; cap zoom so necks don't clip hard */
      var target = 0.9;
      var zoom = target / contentH;
      if (zoom < 1) zoom = 1;
      if (zoom > 1.45) zoom = 1.45;

      img.style.setProperty('--wd-bottle-shift', (padBottom * 100).toFixed(2) + '%');
      img.style.setProperty('--wd-bottle-scale', zoom.toFixed(3));
      img.__wdAligned = true;
      img.classList.add('is-aligned');
    }

    function run() {
      if (img.complete && img.naturalWidth) {
        measureAndApply();
      } else {
        img.addEventListener(
          'load',
          function () {
            measureAndApply();
          },
          { once: true }
        );
      }
    }

    run();
  }

  function initBottleAlign(scope) {
    (scope || document).querySelectorAll('img.wd-product-card__img[data-wd-align="bottle"]').forEach(alignBottleImage);
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(bindPress);
    (scope || document).querySelectorAll('.wd-product-card__img[data-fallback]').forEach(bindBottleFallback);
    initBottleAlign(scope);
  }

  function initReveal(scope) {
    var nodes = (scope || document).querySelectorAll('[data-wd-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.classList.add('is-revealed');
      });
      return;
    }

    if (!window.__wdRevealObserver) {
      window.__wdRevealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            window.__wdRevealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.12 }
      );
    }

    nodes.forEach(function (node) {
      if (node.__wdRevealBound) return;
      node.__wdRevealBound = true;
      window.__wdRevealObserver.observe(node);
    });
  }

  function initDateParallax(scope) {
    var roots = (scope || document).querySelectorAll('[data-wd-date-parallax]');
    if (!roots.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    roots.forEach(function (root) {
      if (root.__wdDateParallaxBound) return;
      root.__wdDateParallaxBound = true;

      var photo = root.querySelector('[data-wd-date-layer="photo"]');
      var city = root.querySelector('[data-wd-date-layer="city"]');
      var fx = root.querySelector('[data-wd-date-layer="fx"]');
      if (!photo) return;

      var targetX = 0;
      var targetY = 0;
      var curX = 0;
      var curY = 0;
      var raf = 0;

      function tick() {
        curX += (targetX - curX) * 0.08;
        curY += (targetY - curY) * 0.08;
        /* City furthest / slowest; photo mid; table FX (candle/glasses) nearest */
        if (city) {
          city.style.transform =
            'translate3d(' + (curX * 0.22).toFixed(2) + 'px,' + (curY * 0.18).toFixed(2) + 'px,0)';
        }
        photo.style.transform =
          'translate3d(' + (curX * 0.55).toFixed(2) + 'px,' + (curY * 0.45).toFixed(2) + 'px,0)';
        if (fx) {
          fx.style.transform =
            'translate3d(' + (curX * 1.05).toFixed(2) + 'px,' + (curY * 0.95).toFixed(2) + 'px,0)';
        }
        if (Math.abs(targetX - curX) > 0.05 || Math.abs(targetY - curY) > 0.05) {
          raf = requestAnimationFrame(tick);
        } else {
          raf = 0;
        }
      }

      function onMove(e) {
        var rect = root.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var nx = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
        var ny = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
        targetX = nx * 10;
        targetY = ny * 6;
        if (!raf) raf = requestAnimationFrame(tick);
      }

      function onLeave() {
        targetX = 0;
        targetY = 0;
        if (!raf) raf = requestAnimationFrame(tick);
      }

      root.addEventListener('pointermove', onMove, { passive: true });
      root.addEventListener('pointerleave', onLeave);
    });
  }

  function updateCarouselButtons(root) {
    var track = root.querySelector('[data-wd-carousel-track]');
    var prev = root.querySelector('[data-wd-carousel-prev]');
    var next = root.querySelector('[data-wd-carousel-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  function scrollCarouselByPage(root, dir) {
    var track = root.querySelector('[data-wd-carousel-track]');
    if (!track) return;
    var slide = track.querySelector('.wd-carousel__slide');
    var gap = 16;
    var amount = slide ? slide.offsetWidth + gap : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-wd-carousel]').forEach(function (root) {
      if (root.__wdCarouselBound) return;
      root.__wdCarouselBound = true;
      var track = root.querySelector('[data-wd-carousel-track]');
      if (!track) return;
      track.addEventListener(
        'scroll',
        function () {
          updateCarouselButtons(root);
        },
        { passive: true }
      );
      updateCarouselButtons(root);
    });
  }

  function getActiveCurationTrack(root) {
    var panel = root.querySelector('.wd-curation-tabs__panel.is-active');
    if (!panel) panel = root.querySelector('[data-wd-ctab-panel]:not([hidden])');
    return panel ? panel.querySelector('[data-wd-carousel-track]') : null;
  }

  function updateCurationTabButtons(root) {
    var track = getActiveCurationTrack(root);
    var prev = root.querySelector('[data-wd-ctab-prev]');
    var next = root.querySelector('[data-wd-ctab-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  function scrollCurationTab(root, dir) {
    var track = getActiveCurationTrack(root);
    if (!track) return;
    var slide = track.querySelector('.wd-carousel__slide');
    var amount = slide ? slide.offsetWidth + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  function activateCurationTab(root, index) {
    var tabs = root.querySelectorAll('[data-wd-ctab]');
    var panels = root.querySelectorAll('[data-wd-ctab-panel]');
    var allLink = root.querySelector('[data-wd-ctab-all]');
    var i = Number(index) || 0;
    tabs.forEach(function (tab) {
      var on = Number(tab.getAttribute('data-wd-ctab-index')) === i;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && allLink) {
        var url = tab.getAttribute('data-wd-ctab-url');
        if (url) allLink.setAttribute('href', url);
      }
    });
    panels.forEach(function (panel) {
      var on = Number(panel.getAttribute('data-wd-ctab-index')) === i;
      panel.classList.toggle('is-active', on);
      if (on) {
        panel.removeAttribute('hidden');
        var track = panel.querySelector('[data-wd-carousel-track]');
        if (track) track.scrollLeft = 0;
        ensureCurationPanelLoaded(panel, root);
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    updateCurationTabButtons(root);
  }

  function ensureCurationPanelLoaded(panel, root) {
    if (!panel || panel.getAttribute('data-wd-ctab-loaded') === '1') return;
    var lazyUrl = panel.getAttribute('data-wd-ctab-lazy');
    if (!lazyUrl) {
      panel.setAttribute('data-wd-ctab-loaded', '1');
      return;
    }
    var track = panel.querySelector('[data-wd-carousel-track]');
    if (!track) return;
    if (panel.__wdCtabLoading) return;
    panel.__wdCtabLoading = true;

    var urls = [lazyUrl];
    var extra = panel.getAttribute('data-wd-ctab-lazy-extra') || '';
    if (extra) {
      extra.split('|').forEach(function (u) {
        u = (u || '').trim();
        if (u) urls.push(u);
      });
    }
    var limit = parseInt(panel.getAttribute('data-wd-ctab-limit') || '8', 10);
    if (!limit || limit < 1) limit = 8;

    function extractSlides(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var strip = tmp.querySelector('[data-wd-cards-strip]');
      var nodeList = strip
        ? strip.querySelectorAll('.wd-carousel__slide')
        : tmp.querySelectorAll('.wd-carousel__slide');
      return Array.prototype.slice.call(nodeList);
    }

    function slideProductId(slide) {
      var card = slide.querySelector('[data-product-id], .wd-product-card');
      if (!card) return '';
      return String(card.getAttribute('data-product-id') || '');
    }

    Promise.all(
      urls.map(function (u) {
        return fetch(u, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('lazy tab ' + r.status);
          return r.text();
        });
      })
    )
      .then(function (htmls) {
        var seen = Object.create(null);
        var merged = [];
        htmls.forEach(function (html) {
          extractSlides(html).forEach(function (slide) {
            if (merged.length >= limit) return;
            var id = slideProductId(slide);
            if (id && seen[id]) return;
            if (id) seen[id] = true;
            merged.push(slide);
          });
        });
        if (merged.length) {
          track.innerHTML = '';
          merged.forEach(function (slide) {
            track.appendChild(slide);
          });
        }
        panel.setAttribute('data-wd-ctab-loaded', '1');
        panel.removeAttribute('data-wd-ctab-lazy');
        panel.removeAttribute('data-wd-ctab-lazy-extra');
        updateCurationTabButtons(root);
      })
      .catch(function () {
        var fallback = panel.getAttribute('data-wd-ctab-index');
        var tab = root.querySelector('[data-wd-ctab][data-wd-ctab-index="' + fallback + '"]');
        var url = tab && tab.getAttribute('data-wd-ctab-url');
        if (url) window.location.href = url;
      })
      .finally(function () {
        panel.__wdCtabLoading = false;
      });
  }

  function initCurationTabs(scope) {
    (scope || document).querySelectorAll('[data-wd-curation-tabs]').forEach(function (root) {
      if (root.__wdCurationTabsBound) return;
      root.__wdCurationTabsBound = true;
      root.querySelectorAll('[data-wd-carousel-track]').forEach(function (track) {
        track.addEventListener(
          'scroll',
          function () {
            if (!track.closest('.wd-curation-tabs__panel.is-active')) return;
            updateCurationTabButtons(root);
          },
          { passive: true }
        );
      });
      updateCurationTabButtons(root);
    });
  }

  if (!window.__wdCarouselClickBound) {
    window.__wdCarouselClickBound = true;
    document.addEventListener('click', function (e) {
      var tabsRoot = e.target.closest('[data-wd-curation-tabs]');
      if (tabsRoot) {
        var tabBtn = e.target.closest('[data-wd-ctab]');
        if (tabBtn && tabsRoot.contains(tabBtn)) {
          e.preventDefault();
          activateCurationTab(tabsRoot, tabBtn.getAttribute('data-wd-ctab-index'));
          return;
        }
        if (e.target.closest('[data-wd-ctab-prev]')) {
          e.preventDefault();
          scrollCurationTab(tabsRoot, -1);
          return;
        }
        if (e.target.closest('[data-wd-ctab-next]')) {
          e.preventDefault();
          scrollCurationTab(tabsRoot, 1);
          return;
        }
      }
      var root = e.target.closest('[data-wd-carousel]');
      if (!root || root.hasAttribute('data-wd-curation-tabs')) return;
      if (e.target.closest('[data-wd-carousel-prev]')) scrollCarouselByPage(root, -1);
      if (e.target.closest('[data-wd-carousel-next]')) scrollCarouselByPage(root, 1);
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-wd-carousel]').forEach(updateCarouselButtons);
      document.querySelectorAll('[data-wd-curation-tabs]').forEach(updateCurationTabButtons);
    });
  }

  function setCatalogFiltersOpen(root, open) {
    if (!root) return;
    root.classList.toggle('is-filters-open', open);
    var toggle = root.querySelector('[data-wd-catalog-filters-open]');
    var scrim = root.querySelector('.wd-catalog__filters-scrim');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (scrim) scrim.hidden = !open;
    document.documentElement.classList.toggle('wd-catalog-filters-lock', open);
  }

  function getCatalogRoot() {
    return document.querySelector('[data-wd-catalog]');
  }

  function getCatalogSectionId(root) {
    if (!root) return '';
    return (
      root.getAttribute('data-wd-section-id') ||
      (root.closest('.shopify-section') && root.closest('.shopify-section').id
        ? root.closest('.shopify-section').id.replace(/^shopify-section-/, '')
        : '')
    );
  }

  /** Read quick-filter from URL: ?wd=sparkling or ?wd=sparkling,red or ?view=wd-sparkling */
  function getWdFilterFromLocation(url) {
    try {
      var u = url || window.location;
      var params = new URLSearchParams(u.search || '');
      var wd = params.get('wd');
      if (wd) return String(wd).toLowerCase().replace(/\+/g, ',').replace(/\|/g, ',');
      var view = params.get('view') || '';
      var m = /^wd-(sparkling|still|red|white|rose)$/i.exec(view);
      if (m) return m[1].toLowerCase();
    } catch (err) {}
    return '';
  }

  function parseWdTokens(wd) {
    if (!wd) return [];
    return String(wd)
      .toLowerCase()
      .split(/[,+|]/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function composeWdTokens(tokens) {
    var style = '';
    var colors = [];
    (tokens || []).forEach(function (t) {
      if (t === 'sparkling' || t === 'still') style = t;
      else if ((t === 'red' || t === 'white' || t === 'rose') && colors.indexOf(t) === -1) colors.push(t);
    });
    var out = [];
    if (style) out.push(style);
    return out.concat(colors).join(',');
  }

  var WD_STYLE_TOKENS = { sparkling: true, still: true };
  var WD_COLOR_TOKENS = { red: true, white: true, rose: true };
  var WD_VARIETY_GID = { '19311': 'red', '19312': 'white', '10045': 'rose' };
  var WD_STYLE_GID = { '55754': 'sparkling', '55755': 'still' };

  function colorFromVarietyValue(raw) {
    var s = String(raw || '');
    var keys = Object.keys(WD_VARIETY_GID);
    for (var i = 0; i < keys.length; i++) {
      if (s.indexOf(keys[i]) !== -1) return WD_VARIETY_GID[keys[i]];
    }
    return '';
  }

  function styleFromStyleValue(raw) {
    var s = String(raw || '');
    var keys = Object.keys(WD_STYLE_GID);
    for (var i = 0; i < keys.length; i++) {
      if (s.indexOf(keys[i]) !== -1) return WD_STYLE_GID[keys[i]];
    }
    return '';
  }

  /** Resolve UI tokens from URL (?wd= + wine-variety / wine-style GIDs). */
  function resolveCatalogUiState(root, url) {
    var params;
    try {
      params = new URLSearchParams((url || window.location).search || '');
    } catch (e) {
      params = new URLSearchParams();
    }
    var tokens = parseWdTokens(params.get('wd') || getWdFilterFromLocation(url));
    var colors = {};
    var style = '';
    tokens.forEach(function (t) {
      if (WD_COLOR_TOKENS[t]) colors[t] = true;
      if (WD_STYLE_TOKENS[t]) style = t;
    });

    // Only map taxonomy GIDs from the current URL — do NOT match against chip hrefs.
    // Chip hrefs from url_to_add often keep the already-selected variety, which
    // would mark Красное+Белое+Розовое active at once.
    params.forEach(function (v, k) {
      var lk = String(k).toLowerCase();
      if (lk.indexOf('wine-variety') !== -1 || lk.indexOf('wine_variety') !== -1 || lk.indexOf('wine.color') !== -1) {
        var c = colorFromVarietyValue(v);
        if (c) colors[c] = true;
      }
      if (lk.indexOf('wine-style') !== -1 || lk.indexOf('wine_style') !== -1) {
        var st = styleFromStyleValue(v);
        if (st) style = st;
      }
    });

    var sweet = parseWdTokens(params.get('wd_sweet'));
    var spark = parseWdTokens(params.get('wd_spark'));
    var fmt = parseWdTokens(params.get('wd_fmt'));
    var hasColor = Object.keys(colors).length > 0;
    var hasStyle = !!style;
    var hasExtra = sweet.length + spark.length + fmt.length > 0;
    var hasSd = false;
    params.forEach(function (_v, k) {
      if (String(k).indexOf('filter.') === 0) hasSd = true;
    });

    return {
      colors: colors,
      style: style,
      sweet: sweet,
      spark: spark,
      fmt: fmt,
      hasColor: hasColor,
      hasStyle: hasStyle,
      hasExtra: hasExtra,
      hasSd: hasSd,
      isAll: !hasColor && !hasStyle && !hasExtra
    };
  }

  function syncCatalogFilterUi(root, url) {
    if (!root) return;
    var state = resolveCatalogUiState(root, url);
    root.querySelectorAll('[data-wd-filter-value]').forEach(function (el) {
      // Skip removable active-filter chips — their presence is enough
      if (el.classList.contains('wd-catalog__active-chip')) return;
      var val = el.getAttribute('data-wd-filter-value') || '';
      var axis = el.getAttribute('data-wd-filter-axis') || '';
      var active = false;
      if (axis === 'all') {
        active = state.isAll;
      } else if (axis === 'style') {
        active = val !== '' && state.style === val;
      } else if (axis === 'color') {
        active = !!state.colors[val] || (val === 'sparkling' && state.style === 'sparkling');
      } else if (axis === 'sweet') {
        active = state.sweet.indexOf(val) !== -1;
      } else if (axis === 'spark') {
        active = state.spark.indexOf(val) !== -1;
      } else if (axis === 'fmt') {
        active = state.fmt.indexOf(val) !== -1;
      }
      el.classList.toggle('is-active', active);
    });
  }

  function collectAxisFilterKeys(root, axis) {
    var keys = {};
    if (!root) return keys;
    root.querySelectorAll('[data-wd-filter-axis="' + axis + '"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href) return;
      try {
        var u = new URL(href, window.location.origin);
        u.searchParams.forEach(function (_v, k) {
          if (String(k).indexOf('filter.') === 0) keys[k] = true;
        });
      } catch (err) {}
    });
    return keys;
  }

  /** Merge style/color chip click into current URL so filters don't replace each other.
   *  Style (тихое/игристое): keep/apply Shopify wine-style S&D from the chip href
   *  (Admin metafields are the source of truth). Colors stay on ?wd=.
   */
  function mergeCatalogAxisUrl(link, clickedUrl) {
    var axis = link.getAttribute('data-wd-filter-axis');
    if (!axis || (axis !== 'style' && axis !== 'color' && axis !== 'all' && axis !== 'sweet' && axis !== 'spark' && axis !== 'fmt'))
      return clickedUrl;

    var root = getCatalogRoot();
    var next = new URLSearchParams(window.location.search);
    var clickedVal = link.getAttribute('data-wd-filter-value') || '';
    var tokens = parseWdTokens(next.get('wd'));

    function deleteKeys(map) {
      Object.keys(map).forEach(function (k) {
        next.delete(k);
      });
    }

    function stripWineVarietyOnly() {
      var kill = [];
      next.forEach(function (_v, k) {
        var lk = String(k).toLowerCase();
        if (
          lk.indexOf('wine-variety') !== -1 ||
          lk.indexOf('wine_variety') !== -1 ||
          lk.indexOf('filter.p.m.wine.color') !== -1 ||
          lk.indexOf('filter.p.m.custom.wine_type') !== -1
        ) {
          kill.push(k);
        }
      });
      kill.forEach(function (k) {
        next.delete(k);
      });
      deleteKeys(collectAxisFilterKeys(root, 'color'));
    }

    function stripWineStyleParams(params) {
      var kill = [];
      params.forEach(function (_v, k) {
        var lk = String(k).toLowerCase();
        if (lk.indexOf('wine-style') !== -1 || lk.indexOf('wine_style') !== -1) kill.push(k);
      });
      kill.forEach(function (k) {
        params.delete(k);
      });
    }

    function copyWineVarietyFrom(url) {
      stripWineVarietyOnly();
      var pickedKey = '';
      var pickedVal = '';
      try {
        url.searchParams.forEach(function (v, k) {
          var lk = String(k).toLowerCase();
          if (
            lk.indexOf('wine-variety') === -1 &&
            lk.indexOf('wine_variety') === -1 &&
            lk.indexOf('filter.p.m.wine.color') === -1 &&
            lk.indexOf('filter.p.m.custom.wine_type') === -1
          ) {
            return;
          }
          var mapped = colorFromVarietyValue(v);
          // Prefer the variety that matches the clicked color chip
          if (clickedVal && mapped === clickedVal) {
            pickedKey = k;
            pickedVal = v;
          } else if (!pickedKey) {
            pickedKey = k;
            pickedVal = v;
          }
        });
      } catch (errV) {}
      if (pickedKey && pickedVal) next.append(pickedKey, pickedVal);
    }

    function copyWineStyleFrom(url) {
      stripWineStyleParams(next);
      var pickedKey = '';
      var pickedVal = '';
      try {
        url.searchParams.forEach(function (v, k) {
          var lk = String(k).toLowerCase();
          if (lk.indexOf('wine-style') === -1 && lk.indexOf('wine_style') === -1) return;
          var mapped = styleFromStyleValue(v);
          if (clickedVal && mapped === clickedVal) {
            pickedKey = k;
            pickedVal = v;
          } else if (!pickedKey) {
            pickedKey = k;
            pickedVal = v;
          }
        });
      } catch (err) {}
      if (pickedKey && pickedVal) next.append(pickedKey, pickedVal);
    }

    function toggleCsvParam(param, value) {
      var cur = parseWdTokens(next.get(param));
      var on = value && cur.indexOf(value) !== -1;
      if (on) {
        cur = cur.filter(function (t) {
          return t !== value;
        });
      } else if (value) {
        cur.push(value);
      }
      if (cur.length) next.set(param, cur.join(','));
      else next.delete(param);
    }

    if (axis === 'all') {
      var toClear = [];
      next.forEach(function (_v, k) {
        if (String(k).indexOf('filter.') === 0) toClear.push(k);
      });
      toClear.forEach(function (k) {
        next.delete(k);
      });
      next.delete('wd');
      next.delete('view');
      next.delete('wd_sweet');
      next.delete('wd_spark');
      next.delete('wd_fmt');
    } else if (axis === 'style') {
      // Toggle style token; keep colors (red+sparkling allowed, OR in match)
      var styleOn = clickedVal && tokens.indexOf(clickedVal) !== -1;
      if (styleOn) {
        tokens = tokens.filter(function (t) {
          return t !== clickedVal;
        });
      } else if (clickedVal) {
        tokens = tokens.filter(function (t) {
          return !WD_STYLE_TOKENS[t];
        });
        tokens.push(clickedVal);
      }
      var composedStyle = composeWdTokens(tokens);
      if (composedStyle) next.set('wd', composedStyle);
      else next.delete('wd');
      next.delete('view');
      if (clickedVal !== 'sparkling') next.delete('wd_spark');
      stripWineVarietyOnly();
      // Sparkling/still alone → native wine-style S&D (products on page 1 + real count)
      var onlyStyle = composedStyle === 'sparkling' || composedStyle === 'still';
      if (onlyStyle && clickedVal && !styleOn) copyWineStyleFrom(clickedUrl);
      else stripWineStyleParams(next);
    } else if (axis === 'color') {
      // Multi-select: Красное + Белое + Розовое (+ Игристое)
      var colorOn = clickedVal && tokens.indexOf(clickedVal) !== -1;
      if (colorOn) {
        tokens = tokens.filter(function (t) {
          return t !== clickedVal;
        });
      } else if (clickedVal) {
        if (clickedVal === 'sparkling' || clickedVal === 'still') {
          tokens = tokens.filter(function (t) {
            return !WD_STYLE_TOKENS[t];
          });
        }
        tokens.push(clickedVal);
      }
      var composedColor = composeWdTokens(tokens);
      if (composedColor) next.set('wd', composedColor);
      else next.delete('wd');
      next.delete('view');
      stripWineVarietyOnly();
      stripWineStyleParams(next);
      // Single red/white/rose → wine-variety S&D (AND with sugar → correct products_count)
      var colorOnly =
        composedColor === 'red' || composedColor === 'white' || composedColor === 'rose';
      if (colorOnly && clickedVal && !colorOn) {
        copyWineVarietyFrom(clickedUrl);
      }
      // Only sparkling → wine-style S&D
      if (composedColor === 'sparkling' && clickedVal === 'sparkling' && !colorOn) {
        copyWineStyleFrom(clickedUrl);
      }
    } else if (axis === 'sweet') {
      toggleCsvParam('wd_sweet', clickedVal);
      // Keep S&D sweetness in sync when chip href has it (multi OR within facet)
      var sweetKeys = [];
      next.forEach(function (_v, k) {
        var lk = String(k).toLowerCase();
        if (lk.indexOf('wine-sweetness') !== -1 || lk.indexOf('sweetness') !== -1) sweetKeys.push(k);
      });
      // Rebuild sweetness S&D from currently selected wd_sweet via chip hrefs in DOM
      sweetKeys.forEach(function (k) {
        next.delete(k);
      });
      var sweetSelected = parseWdTokens(next.get('wd_sweet'));
      if (sweetSelected.length && root) {
        root.querySelectorAll('[data-wd-filter-axis="sweet"][data-wd-filter-value]').forEach(function (a) {
          var val = a.getAttribute('data-wd-filter-value') || '';
          if (sweetSelected.indexOf(val) === -1) return;
          try {
            var u = new URL(a.getAttribute('href') || '', window.location.origin);
            u.searchParams.forEach(function (v, k) {
              var lk = String(k).toLowerCase();
              if (lk.indexOf('wine-sweetness') !== -1 || (lk.indexOf('filter.') === 0 && lk.indexOf('sweet') !== -1)) {
                next.append(k, v);
              }
            });
          } catch (eSw) {}
        });
      }
    } else if (axis === 'spark') {
      if (!tokens.includes('sparkling')) {
        tokens = tokens.filter(function (t) {
          return !WD_STYLE_TOKENS[t];
        });
        tokens.push('sparkling');
        next.set('wd', composeWdTokens(tokens));
      }
      toggleCsvParam('wd_spark', clickedVal);
      copyWineStyleFrom(clickedUrl);
    } else if (axis === 'fmt') {
      toggleCsvParam('wd_fmt', clickedVal);
    }

    if (!next.has('sort_by') && clickedUrl.searchParams.get('sort_by')) {
      next.set('sort_by', clickedUrl.searchParams.get('sort_by'));
    }

    next.delete('page');

    var out = new URL(window.location.pathname, window.location.origin);
    next.forEach(function (v, k) {
      out.searchParams.append(k, v);
    });
    return out;
  }

  function locationHasSdFilter(url) {
    try {
      var u = url || window.location;
      var params = new URLSearchParams(u.search || '');
      var found = false;
      params.forEach(function (_value, key) {
        if (String(key).indexOf('filter.') === 0) found = true;
      });
      return found;
    } catch (err) {
      return false;
    }
  }

  function cardLooksSparkling(card) {
    var kind = (card.getAttribute('data-wd-kind') || '').toLowerCase();
    if (kind.indexOf('sparkling') !== -1) return true;
    var titleEl = card.querySelector('.wd-product-card__title, .wd-product-card__name, [data-wd-title]');
    var link = card.getAttribute('href') || (card.querySelector('a') && card.querySelector('a').getAttribute('href')) || '';
    var blob = (
      kind +
      ' ' +
      ((titleEl && titleEl.textContent) || '') +
      ' ' +
      link +
      ' ' +
      (card.getAttribute('data-product-handle') || '')
    ).toLowerCase();
    return /prosecco|просекк|игрист|sparkling|шампан|cava|cremant|crémant|креман|frizzante|фризанте|spumante|brut|lambrusco|champagne|mionetto|cordon[-\s]?negro|ice[-\s]?ros|franciacorta|asti/.test(
      blob
    );
  }

  function cardMatchesWdFilter(kind, filter, card) {
    if (!filter) return true;
    var parts = kind
      ? String(kind)
          .toLowerCase()
          .split('|')
          .map(function (p) {
            return p.trim();
          })
          .filter(Boolean)
      : [];
    var tokens = parseWdTokens(filter);
    var needStyle = tokens.filter(function (t) {
      return WD_STYLE_TOKENS[t];
    });
    var needColor = tokens.filter(function (t) {
      return WD_COLOR_TOKENS[t];
    });
    // Цвет group: red/white/rose/sparkling/still → OR (not AND)
    var group = needStyle.concat(needColor);
    if (!group.length) return true;
    return group.some(function (t) {
      if (t === 'still') {
        if (card && cardLooksSparkling(card)) return false;
        return parts.indexOf('still') !== -1 || parts.indexOf('sparkling') === -1;
      }
      if (t === 'sparkling') {
        if (parts.indexOf('sparkling') !== -1) return true;
        return !!(card && cardLooksSparkling(card));
      }
      return parts.indexOf(t) !== -1;
    });
  }

  function csvParamMatches(cardAttr, paramCsv) {
    if (!paramCsv) return true;
    var have = String(cardAttr || '')
      .toLowerCase()
      .trim();
    var need = parseWdTokens(paramCsv);
    if (!need.length) return true;
    return need.indexOf(have) !== -1;
  }

  function locationHasFilterKey(params, needle) {
    var found = false;
    try {
      params.forEach(function (_v, k) {
        if (String(k).toLowerCase().indexOf(needle) !== -1) found = true;
      });
    } catch (e) {}
    return found;
  }

  function cardMatchesExtraFilters(card) {
    try {
      var params = new URLSearchParams(window.location.search);
      // When native S&D already filtered sweetness, do NOT re-hide by data-wd-sweet
      // (classification on cards is often empty/wrong → empty grid + correct count).
      if (!locationHasFilterKey(params, 'wine-sweetness')) {
        if (!csvParamMatches(card.getAttribute('data-wd-sweet'), params.get('wd_sweet'))) return false;
      }
      if (!csvParamMatches(card.getAttribute('data-wd-spark'), params.get('wd_spark'))) return false;
      if (!csvParamMatches(card.getAttribute('data-wd-fmt'), params.get('wd_fmt'))) return false;
    } catch (err) {}
    return true;
  }

  function catalogCountSuffix(n) {
    var abs = Math.abs(parseInt(n, 10) || 0);
    var n10 = abs % 10;
    var n100 = abs % 100;
    if (n10 === 1 && n100 !== 11) return 'позиция';
    if (n10 >= 2 && n10 <= 4 && (n100 < 10 || n100 >= 20)) return 'позиции';
    return 'позиций';
  }

  function syncCatalogFilterCount(root) {
    if (!root) return;
    var countEl = root.querySelector('[data-wd-filter-count]');
    if (!countEl) return;

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      params = new URLSearchParams();
    }
    var wd = getWdFilterFromLocation();
    var tokens = parseWdTokens(wd);
    var hasVarietySd = locationHasFilterKey(params, 'wine-variety') || locationHasFilterKey(params, 'wine.color');
    var hasStyleSd = locationHasFilterKey(params, 'wine-style');
    var hasSweetSd = locationHasFilterKey(params, 'wine-sweetness');
    var colorTokens = tokens.filter(function (t) {
      return WD_COLOR_TOKENS[t];
    });
    var styleTokens = tokens.filter(function (t) {
      return WD_STYLE_TOKENS[t];
    });
    // Facet totals apply for bare ?wd=… (no S&D). With wine-style S&D, trust products_count.
    var onlyKind =
      (colorTokens.length > 0 || styleTokens.length > 0) &&
      !params.get('wd_sweet') &&
      !params.get('wd_spark') &&
      !params.get('wd_fmt') &&
      !hasVarietySd &&
      !hasStyleSd &&
      !hasSweetSd;

    var serverN = parseInt(countEl.getAttribute('data-wd-server-count'), 10);
    var trustTotal =
      countEl.getAttribute('data-wd-count-total') === '1' ||
      root.getAttribute('data-wd-liquid-filtered') === '1';

    // Single color/style: prefer facet chip count BEFORE trusting Liquid products_count (often 86 = full catalog)
    if (onlyKind && colorTokens.length + styleTokens.length === 1) {
      var want = colorTokens[0] || styleTokens[0];
      var facetEl = root.querySelector(
        '[data-wd-filter-axis="color"][data-wd-filter-value="' +
          want +
          '"][data-wd-facet-count], [data-wd-filter-axis="style"][data-wd-filter-value="' +
          want +
          '"][data-wd-facet-count]'
      );
      if (facetEl) {
        var facetN = parseInt(facetEl.getAttribute('data-wd-facet-count'), 10);
        if (!isNaN(facetN) && facetN >= 0) {
          var facetSuffix = catalogCountSuffix(facetN);
          countEl.setAttribute('data-wd-server-count', String(facetN));
          countEl.setAttribute('data-wd-count-total', '1');
          countEl.setAttribute('data-count-suffix', facetSuffix);
          countEl.textContent = facetN + ' ' + facetSuffix;
          return;
        }
      }
    }

    // Multi exclusive colors (no sparkling): sum facet counts
    if (onlyKind && colorTokens.length > 1 && styleTokens.length === 0) {
      var sum = 0;
      var ok = true;
      colorTokens.forEach(function (t) {
        var el = root.querySelector(
          '[data-wd-filter-axis="color"][data-wd-filter-value="' + t + '"][data-wd-facet-count]'
        );
        var n = el ? parseInt(el.getAttribute('data-wd-facet-count'), 10) : NaN;
        if (isNaN(n)) ok = false;
        else sum += n;
      });
      if (ok) {
        var sumSuffix = catalogCountSuffix(sum);
        countEl.setAttribute('data-wd-server-count', String(sum));
        countEl.setAttribute('data-wd-count-total', '1');
        countEl.setAttribute('data-count-suffix', sumSuffix);
        countEl.textContent = sum + ' ' + sumSuffix;
        return;
      }
    }

    // Liquid/S&D already computed the FULL matching total — never replace with page DOM size
    if (trustTotal && !isNaN(serverN) && serverN >= 0) {
      // Color/style via ?wd= + sugar without wine-variety: products_count is sugar-only.
      // Prefer cards actually rendered (intersect), including when count is 1 not 0.
      var mixedAxes =
        (colorTokens.length > 0 || styleTokens.length > 0) &&
        (!!params.get('wd_sweet') || hasSweetSd || !!params.get('wd_spark') || !!params.get('wd_fmt'));
      if (mixedAxes && !hasVarietySd) {
        var grid = root.querySelector('[data-wd-filter-products]');
        var emptyWrap = root.querySelector('.wd-catalog__empty-wrap, [data-wd-filter-empty]');
        var emptyVisible = false;
        if (emptyWrap) {
          emptyVisible =
            !emptyWrap.hidden &&
            emptyWrap.style.display !== 'none' &&
            !emptyWrap.classList.contains('is-wd-filtered-out');
        }
        var n = 0;
        if (grid && !emptyVisible) {
          grid.querySelectorAll('.wd-product-card').forEach(function (card) {
            if (card.hidden) return;
            if (card.classList.contains('is-wd-filtered-out')) return;
            if (card.style && String(card.style.display || '').indexOf('none') !== -1) return;
            n += 1;
          });
        }
        var mixSuffix = catalogCountSuffix(n);
        countEl.setAttribute('data-wd-server-count', String(n));
        countEl.setAttribute('data-count-suffix', mixSuffix);
        countEl.textContent = n + ' ' + mixSuffix;
        return;
      }
      var trustSuffix = catalogCountSuffix(serverN);
      countEl.setAttribute('data-count-suffix', trustSuffix);
      countEl.textContent = serverN + ' ' + trustSuffix;
      return;
    }

    if (!isNaN(serverN) && serverN >= 0) {
      var suffix = catalogCountSuffix(serverN);
      countEl.setAttribute('data-count-suffix', suffix);
      countEl.textContent = serverN + ' ' + suffix;
      return;
    }

    var shown = 0;
    root.querySelectorAll('.wd-catalog__products .wd-product-card, [data-wd-filter-products] .wd-product-card').forEach(function (card) {
      if (card.hidden) return;
      if (card.classList.contains('is-wd-filtered-out')) return;
      if (card.style && String(card.style.display || '').indexOf('none') !== -1) return;
      shown += 1;
    });
    var fallbackSuffix = catalogCountSuffix(shown);
    countEl.setAttribute('data-count-suffix', fallbackSuffix);
    countEl.textContent = shown + ' ' + fallbackSuffix;
  }

  function applyWdQuickFilter(root, filter, options) {
    if (!root) return;
    options = options || {};
    // Always mutate the grid for catalog ?wd= — CSS alone is unreliable
    // (.wd-product-card { display:flex !important } elsewhere in the stylesheet).
    var hideCards = options.hideCards !== false;
    var removeMismatch = options.removeMismatch === true && hideCards;
    var productsEl = root.querySelector('[data-wd-filter-products]');
    var cards = root.querySelectorAll('[data-wd-kind], .wd-catalog__products .wd-product-card');
    var shown = 0;
    var toRemove = [];
    var tokens = parseWdTokens(filter);

    cards.forEach(function (card) {
      var kind = (card.getAttribute('data-wd-kind') || '').toLowerCase();
      var match = cardMatchesWdFilter(kind, filter, card) && cardMatchesExtraFilters(card);
      if (hideCards) {
        if (match) {
          card.hidden = false;
          card.classList.remove('is-wd-filtered-out');
          card.style.removeProperty('display');
          shown += 1;
        } else if (removeMismatch) {
          toRemove.push(card);
        } else {
          card.hidden = true;
          card.classList.add('is-wd-filtered-out');
          card.style.setProperty('display', 'none', 'important');
        }
      } else {
        card.hidden = false;
        card.classList.remove('is-wd-filtered-out');
        card.style.removeProperty('display');
        if (match) shown += 1;
      }
    });

    toRemove.forEach(function (card) {
      if (card && card.parentNode) card.parentNode.removeChild(card);
    });

    // Active checkmarks / chips: always from full URL (incl. S&D), not client-filter subset
    syncCatalogFilterUi(root, options.url || window.location);

    if (hideCards) {
      var countEl = root.querySelector('[data-wd-filter-count]');
      var hasExtraFilter = false;
      try {
        var qp = new URLSearchParams(window.location.search);
        hasExtraFilter = !!(qp.get('wd_sweet') || qp.get('wd_spark') || qp.get('wd_fmt'));
      } catch (errCount) {}
      var clientFiltering = !!(filter || hasExtraFilter);
      // Never overwrite data-wd-server-count with page-local card count.
      // Toolbar must show total matching filters (from Liquid/S&D).
      if (countEl) {
        syncCatalogFilterCount(root);
      }

      var emptyEl = root.querySelector('[data-wd-filter-empty]');
      if (!emptyEl && productsEl && productsEl.parentNode) {
        emptyEl = document.createElement('p');
        emptyEl.className = 'wd-catalog__empty';
        emptyEl.setAttribute('data-wd-filter-empty', '');
        emptyEl.textContent = productsEl.getAttribute('data-empty-text') || 'Нет товаров';
        productsEl.parentNode.insertBefore(emptyEl, productsEl);
      }
      if (emptyEl) {
        var showEmpty = !!(clientFiltering && shown === 0);
        emptyEl.hidden = !showEmpty;
        emptyEl.classList.toggle('is-wd-filtered-out', !showEmpty);
        emptyEl.style.setProperty('display', showEmpty ? '' : 'none', 'important');
        if (showEmpty) emptyEl.style.removeProperty('display');
      }

      if (productsEl) {
        var hideProducts = !!(clientFiltering && shown === 0);
        productsEl.hidden = hideProducts;
        productsEl.classList.toggle('is-wd-filtered-out', hideProducts);
        if (hideProducts) {
          productsEl.style.setProperty('display', 'none', 'important');
        } else {
          productsEl.style.removeProperty('display');
        }
      }
    }
  }

  var __wdCatalogAjaxController = null;
  var __wdCatalogAjaxBusy = false;

  function buildCatalogFetchUrl(targetUrl, sectionId) {
    var url = new URL(targetUrl.href || targetUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url;
  }

  function buildCatalogPushUrl(targetUrl) {
    var url = new URL(targetUrl.href || targetUrl, window.location.origin);
    url.searchParams.delete('section_id');
    return url.pathname + url.search + url.hash;
  }

  function extractCatalogSectionHtml(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var byId = doc.getElementById('shopify-section-' + sectionId);
    if (byId) return byId;
    var catalog = doc.querySelector('[data-wd-catalog]');
    if (catalog) {
      var wrap = catalog.closest('.shopify-section');
      return wrap || catalog;
    }
    return doc.body && doc.body.firstElementChild;
  }

  function loadCatalogSection(targetUrl, options) {
    options = options || {};
    var push = options.push !== false;
    var replace = options.replace === true;
    if (replace) push = false;
    var root = getCatalogRoot();
    var sectionId = getCatalogSectionId(root);
    if (!root || !sectionId) {
      window.location.href = String(targetUrl.href || targetUrl);
      return Promise.resolve();
    }

    var shopifySection = root.closest('.shopify-section') || root;
    var scrollY = window.scrollY;
    var fetchUrl = buildCatalogFetchUrl(targetUrl, sectionId);

    if (__wdCatalogAjaxController) {
      try {
        __wdCatalogAjaxController.abort();
      } catch (e) {}
    }
    __wdCatalogAjaxController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    __wdCatalogAjaxBusy = true;
    shopifySection.classList.add('is-loading');
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    return fetch(fetchUrl.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      signal: __wdCatalogAjaxController ? __wdCatalogAjaxController.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('catalog fetch ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var incoming = extractCatalogSectionHtml(html, sectionId);
        if (!incoming) throw new Error('catalog section missing');

        var wasFiltersOpen = root.classList.contains('is-filters-open');

        if (incoming.classList && incoming.classList.contains('shopify-section')) {
          shopifySection.innerHTML = incoming.innerHTML;
        } else if (incoming.getAttribute && incoming.getAttribute('data-wd-catalog') != null) {
          root.replaceWith(incoming);
        } else {
          shopifySection.innerHTML = incoming.innerHTML || incoming.outerHTML;
        }

        var newRoot = getCatalogRoot();
        if (wasFiltersOpen && newRoot) setCatalogFiltersOpen(newRoot, true);

        if (replace) {
          history.replaceState({ wdCatalogAjax: true }, '', buildCatalogPushUrl(targetUrl));
        } else if (push) {
          history.pushState({ wdCatalogAjax: true }, '', buildCatalogPushUrl(targetUrl));
        }

        window.scrollTo(0, scrollY);

        // After AJAX: trust Liquid/S&D HTML. Only client-filter when server did not.
        if (newRoot) {
          var pushUrl = new URL(buildCatalogPushUrl(targetUrl), window.location.origin);
          var trustServer = newRoot.getAttribute('data-wd-liquid-filtered') === '1';
          var hasWineStyleSd = false;
          var hasWineVarietySd = false;
          var hasWineSweetnessSd = false;
          try {
            pushUrl.searchParams.forEach(function (_v, k) {
              var lk = String(k).toLowerCase();
              if (lk.indexOf('wine-style') !== -1) hasWineStyleSd = true;
              if (
                lk.indexOf('wine-variety') !== -1 ||
                lk.indexOf('wine_variety') !== -1 ||
                lk.indexOf('wine.color') !== -1
              ) {
                hasWineVarietySd = true;
              }
              if (lk.indexOf('wine-sweetness') !== -1) hasWineSweetnessSd = true;
            });
          } catch (eSd) {}
          var wd = getWdFilterFromLocation(pushUrl);
          var hasExtra = false;
          try {
            hasExtra = !!(pushUrl.searchParams.get('wd_spark') || pushUrl.searchParams.get('wd_fmt'));
            if (pushUrl.searchParams.get('wd_sweet') && !hasWineSweetnessSd) hasExtra = true;
          } catch (eExtra) {}
          var colorOnly = '';
          if (wd && !hasWineVarietySd) {
            colorOnly = parseWdTokens(wd)
              .filter(function (t) {
                return WD_COLOR_TOKENS[t];
              })
              .join(',');
          }
          var styleOnly = '';
          if (wd && !hasWineStyleSd) {
            styleOnly = parseWdTokens(wd)
              .filter(function (t) {
                return WD_STYLE_TOKENS[t];
              })
              .join(',');
          }
          var clientWd = [styleOnly, colorOnly].filter(Boolean).join(',');
          if (!trustServer && (clientWd || hasExtra)) {
            applyWdQuickFilter(newRoot, clientWd, {
              hideCards: true,
              removeMismatch: false,
              url: pushUrl
            });
          }
          syncCatalogFilterUi(newRoot, pushUrl);
          syncCatalogFilterCount(newRoot);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = buildCatalogPushUrl(targetUrl);
      })
      .finally(function () {
        __wdCatalogAjaxBusy = false;
        window.__wdStyleSdUpgradeBusy = false;
        var r = getCatalogRoot();
        var s = r && (r.closest('.shopify-section') || r);
        if (r) {
          r.classList.remove('is-loading');
          r.removeAttribute('aria-busy');
        }
        if (s) s.classList.remove('is-loading');
      });
  }


  function preserveCatalogQuery(targetUrl) {
    var url = new URL(targetUrl.href || targetUrl, window.location.origin);
    var current = new URLSearchParams(window.location.search);
    if (!url.searchParams.has('sort_by') && current.get('sort_by')) {
      url.searchParams.set('sort_by', current.get('sort_by'));
    }
    if (!url.searchParams.has('wd') && current.get('wd')) {
      url.searchParams.set('wd', current.get('wd'));
    }
    if (!url.searchParams.has('wd_sweet') && current.get('wd_sweet')) {
      url.searchParams.set('wd_sweet', current.get('wd_sweet'));
    }
    if (!url.searchParams.has('wd_spark') && current.get('wd_spark')) {
      url.searchParams.set('wd_spark', current.get('wd_spark'));
    }
    if (!url.searchParams.has('wd_fmt') && current.get('wd_fmt')) {
      url.searchParams.set('wd_fmt', current.get('wd_fmt'));
    }
    if (!url.searchParams.has('view') && current.get('view') && String(current.get('view')).indexOf('wd-') === 0) {
      url.searchParams.set('view', current.get('view'));
    }
    // Keep active Search & Discovery filters when pager URL omits them
    current.forEach(function (value, key) {
      if (String(key).indexOf('filter.') === 0 && !url.searchParams.getAll(key).length) {
        url.searchParams.append(key, value);
      }
    });
    return url;
  }

  function loadCatalogMore(btn) {
    if (!btn || __wdCatalogAjaxBusy) return Promise.resolve();

    var root = btn.closest('[data-wd-catalog]') || getCatalogRoot();
    var nextHref = btn.getAttribute('data-next-url');
    var sectionId = getCatalogSectionId(root);
    var productsEl = root && root.querySelector('[data-wd-filter-products]');
    if (!root || !nextHref || !sectionId || !productsEl) {
      if (nextHref) window.location.href = nextHref;
      return Promise.resolve();
    }

    var targetUrl;
    try {
      targetUrl = preserveCatalogQuery(new URL(nextHref, window.location.origin));
    } catch (err) {
      return Promise.resolve();
    }

    var fetchUrl = buildCatalogFetchUrl(targetUrl, sectionId);
    if (__wdCatalogAjaxController) {
      try {
        __wdCatalogAjaxController.abort();
      } catch (e) {}
    }
    __wdCatalogAjaxController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    __wdCatalogAjaxBusy = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    root.setAttribute('aria-busy', 'true');

    return fetch(fetchUrl.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      signal: __wdCatalogAjaxController ? __wdCatalogAjaxController.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('catalog more ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var incoming = extractCatalogSectionHtml(html, sectionId);
        if (!incoming) throw new Error('catalog section missing');

        var incomingRoot =
          (incoming.querySelector && incoming.querySelector('[data-wd-catalog]')) ||
          (incoming.getAttribute && incoming.getAttribute('data-wd-catalog') != null ? incoming : null) ||
          incoming;
        var srcProducts = incomingRoot.querySelector
          ? incomingRoot.querySelector('[data-wd-filter-products]')
          : null;
        if (!srcProducts || !srcProducts.children.length) throw new Error('catalog products missing');

        var existing = {};
        productsEl.querySelectorAll('a[href]').forEach(function (a) {
          var href = a.getAttribute('href');
          if (href) existing[href] = true;
        });

        var appended = document.createDocumentFragment();
        Array.prototype.slice.call(srcProducts.children).forEach(function (card) {
          var link = card.querySelector && card.querySelector('a[href]');
          var href = link && link.getAttribute('href');
          if (href && existing[href]) return;
          appended.appendChild(card);
        });
        productsEl.appendChild(appended);

        if (typeof init === 'function') init(productsEl);
        if (typeof initReveal === 'function') initReveal(productsEl);

        var wd = getWdFilterFromLocation();
        if (wd) {
          applyWdQuickFilter(root, wd, {
            hideCards: true,
            removeMismatch: false
          });
        }
        syncCatalogFilterUi(root);
        syncCatalogFilterCount(root);

        var nextBtn = incomingRoot.querySelector
          ? incomingRoot.querySelector('[data-wd-load-more]')
          : null;
        var nextUrl = nextBtn && nextBtn.getAttribute('data-next-url');
        var wrap = root.querySelector('[data-wd-load-more-wrap]');
        if (nextUrl) {
          btn.setAttribute('data-next-url', nextUrl);
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.setAttribute('aria-busy', 'false');
        } else if (wrap) {
          wrap.remove();
        }

        try {
          history.replaceState({ wdCatalogAjax: true }, '', buildCatalogPushUrl(targetUrl));
        } catch (e) {}
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = buildCatalogPushUrl(targetUrl);
      })
      .finally(function () {
        __wdCatalogAjaxBusy = false;
        var r = getCatalogRoot();
        if (r) r.removeAttribute('aria-busy');
        if (btn && btn.isConnected) {
          btn.classList.remove('is-loading');
          btn.setAttribute('aria-busy', 'false');
          if (btn.closest('[data-wd-load-more-wrap]')) btn.disabled = false;
        }
      });
  }

  function catalogUrlFromForm(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var url = new URL(action, window.location.origin);
    // Preserve current wd/view/filter.* unless form overrides
    var current = new URLSearchParams(window.location.search);
    ['wd', 'view', 'sort_by'].forEach(function (key) {
      if (current.get(key) && !form.querySelector('[name="' + key + '"]')) {
        url.searchParams.set(key, current.get(key));
      }
    });
    current.forEach(function (value, key) {
      if (String(key).indexOf('filter.') !== 0) return;
      if (form.querySelector('[name="' + key + '"]')) return;
      if (!url.searchParams.getAll(key).length) {
        url.searchParams.append(key, value);
      }
    });
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (value === '' || value == null) {
        url.searchParams.delete(key);
      } else if (String(key).indexOf('filter.') === 0) {
        // Price / list filters: last write wins for single-value keys
        url.searchParams.set(key, String(value).replace(/\s/g, ''));
      } else {
        url.searchParams.set(key, String(value));
      }
    });
    url.searchParams.delete('page');
    return url;
  }

  function initCatalogAjax() {
    if (window.__wdCatalogAjaxBound) return;
    window.__wdCatalogAjaxBound = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-wd-catalog-filters-open]');
      if (openBtn) {
        setCatalogFiltersOpen(openBtn.closest('[data-wd-catalog]'), true);
        return;
      }
      var closeEl = e.target.closest('[data-wd-catalog-filters-close]');
      if (closeEl) {
        setCatalogFiltersOpen(closeEl.closest('[data-wd-catalog]'), false);
        return;
      }

      var loadMoreBtn = e.target.closest('[data-wd-load-more]');
      if (loadMoreBtn) {
        e.preventDefault();
        loadCatalogMore(loadMoreBtn);
        return;
      }

      var root = getCatalogRoot();
      if (!root) return;

      var link = e.target.closest('a[data-wd-ajax-filter], .wd-catalog__pager a, a.wd-catalog__chip, a.wd-catalog__value');
      if (!link || !root.contains(link)) return;
      if (link.getAttribute('aria-disabled') === 'true') return;
      if (link.classList.contains('is-disabled')) return;

      var href = link.getAttribute('href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (err) {
        return;
      }

      // Different collection (e.g. top-10) → full navigation
      if (url.pathname !== window.location.pathname) return;

      e.preventDefault();
      if (__wdCatalogAjaxBusy) return;

      var current = new URLSearchParams(window.location.search);
      if (!url.searchParams.has('sort_by') && current.get('sort_by')) {
        url.searchParams.set('sort_by', current.get('sort_by'));
      }

      // Type/color chips: merge axes so Игристое + Красное stay combined
      if (link.hasAttribute('data-wd-filter-axis')) {
        url = mergeCatalogAxisUrl(link, url);
      } else if (!link.hasAttribute('data-wd-filter-value')) {
        // S&D / pager: keep custom WD params Shopify url_to_add drops
        if (!url.searchParams.has('wd') && current.get('wd')) {
          url.searchParams.set('wd', current.get('wd'));
        }
        ['wd_sweet', 'wd_spark', 'wd_fmt'].forEach(function (key) {
          if (!url.searchParams.has(key) && current.get(key)) {
            url.searchParams.set(key, current.get(key));
          }
        });
        if (!url.searchParams.has('view') && current.get('view') && String(current.get('view')).indexOf('wd-') === 0) {
          url.searchParams.set('view', current.get('view'));
        }
        // Country/price etc. → page 1 (pager links keep their page)
        if (!link.closest('.wd-catalog__pager')) {
          url.searchParams.delete('page');
        }
      } else {
        url.searchParams.delete('page');
      }

      loadCatalogSection(url);
    });

    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-wd-ajax-sort]');
      if (!select) return;
      var form = select.form || select.closest('form');
      var root = getCatalogRoot();
      if (!form || !root || !root.contains(select)) return;
      e.preventDefault();
      if (__wdCatalogAjaxBusy) return;
      loadCatalogSection(catalogUrlFromForm(form));
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-wd-ajax-form]');
      var root = getCatalogRoot();
      if (!form || !root || !root.contains(form)) return;
      e.preventDefault();
      if (__wdCatalogAjaxBusy) return;
      loadCatalogSection(catalogUrlFromForm(form));
    });

    window.addEventListener('popstate', function () {
      if (!getCatalogRoot()) return;
      loadCatalogSection(new URL(window.location.href), { push: false });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-wd-catalog].is-filters-open').forEach(function (root) {
        setCatalogFiltersOpen(root, false);
      });
    });
  }

  function initCatalogFilters() {
    initCatalogAjax();
  }

  function initWdQuickFilters() {
    // Do NOT strip wine-style / wine-variety from URL — Admin metafields power S&D.
    var filter = getWdFilterFromLocation();
    var hasExtra = false;
    var hasWineStyleSd = false;
    var hasWineVarietySd = false;
    var hasWineSweetnessSd = false;
    try {
      var p = new URLSearchParams(window.location.search);
      hasExtra = !!(p.get('wd_spark') || p.get('wd_fmt'));
      // wd_sweet only needs client filter when S&D sweetness is absent
      if (p.get('wd_sweet') && !locationHasFilterKey(p, 'wine-sweetness')) {
        hasExtra = true;
      }
      p.forEach(function (_v, k) {
        var lk = String(k).toLowerCase();
        if (lk.indexOf('wine-style') !== -1) hasWineStyleSd = true;
        if (
          lk.indexOf('wine-variety') !== -1 ||
          lk.indexOf('wine_variety') !== -1 ||
          lk.indexOf('wine.color') !== -1
        ) {
          hasWineVarietySd = true;
        }
        if (lk.indexOf('wine-sweetness') !== -1) hasWineSweetnessSd = true;
      });
    } catch (e2) {}

    // Bare ?wd=sparkling / ?wd=still → upgrade to native wine-style S&D URL (page 1 + real count)
    if (!hasWineStyleSd && !window.__wdStyleSdUpgradeBusy) {
      var styleTokensOnly = parseWdTokens(filter).filter(function (t) {
        return WD_STYLE_TOKENS[t];
      });
      var colorTokensOnly = parseWdTokens(filter).filter(function (t) {
        return WD_COLOR_TOKENS[t];
      });
      var bareStyle =
        styleTokensOnly.length === 1 &&
        colorTokensOnly.length === 0 &&
        !hasExtra &&
        !(function () {
          try {
            return !!(new URLSearchParams(window.location.search).get('wd_sweet'));
          } catch (eS) {
            return false;
          }
        })();
      if (bareStyle) {
        var styleWant = styleTokensOnly[0];
        var catalogRoot = getCatalogRoot();
        var styleChip =
          (catalogRoot &&
            catalogRoot.querySelector(
              '[data-wd-filter-value="' +
                styleWant +
                '"][data-wd-filter-axis="color"][href], [data-wd-filter-value="' +
                styleWant +
                '"][data-wd-filter-axis="style"][href]'
            )) ||
          null;
        if (styleChip) {
          try {
            var chipUrl = new URL(styleChip.getAttribute('href') || '', window.location.origin);
            var chipHasStyle = false;
            chipUrl.searchParams.forEach(function (_v, k) {
              if (String(k).toLowerCase().indexOf('wine-style') !== -1) chipHasStyle = true;
            });
            if (chipHasStyle) {
              // Preserve sort / other non-conflicting params
              try {
                var cur = new URLSearchParams(window.location.search);
                if (cur.get('sort_by') && !chipUrl.searchParams.get('sort_by')) {
                  chipUrl.searchParams.set('sort_by', cur.get('sort_by'));
                }
              } catch (eKeep) {}
              window.__wdStyleSdUpgradeBusy = true;
              loadCatalogSection(chipUrl.toString(), { replace: true });
              return;
            }
          } catch (eUp) {}
        }
      }
    }

    document.querySelectorAll('[data-wd-quick-filter]').forEach(function (root) {
      if (root.hasAttribute('data-wd-catalog')) {
        var tokens = parseWdTokens(filter);
        var clientParts = [];
        if (!hasWineStyleSd) {
          tokens.forEach(function (t) {
            if (WD_STYLE_TOKENS[t]) clientParts.push(t);
          });
        }
        if (!hasWineVarietySd) {
          tokens.forEach(function (t) {
            if (WD_COLOR_TOKENS[t]) clientParts.push(t);
          });
        }
        var clientWd = clientParts.join(',');
        // Liquid already filtered ?wd= / ?wd_sweet= into the HTML when possible.
        // Only client-filter when we still need to hide cards (no liquid pass).
        var trustServer = root.getAttribute('data-wd-liquid-filtered') === '1';
        if (!trustServer && (clientWd || hasExtra)) {
          applyWdQuickFilter(root, clientWd, {
            hideCards: true,
            removeMismatch: false
          });
        }
        syncCatalogFilterUi(root);
        syncCatalogFilterCount(root);
        return;
      }
      applyWdQuickFilter(root, filter, { hideCards: true, removeMismatch: false });
    });
  }

  function initMobileDock() {
    if (window.__wdMobileDockBound) return;
    window.__wdMobileDockBound = true;

    function closeMenu() {
      var drawer = document.querySelector('header-drawer');
      var details = document.querySelector('#Details-menu-drawer-container');
      if (drawer && typeof drawer.close === 'function') {
        try {
          drawer.close();
        } catch (err) {}
      }
      if (details) {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
        var summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
      document.body.classList.remove('wd-gw-menu-open');
    }

    function openMenu() {
      var drawer = document.querySelector('header-drawer');
      var details = document.querySelector('#Details-menu-drawer-container');
      if (!details) return;

      // Toggle: second tap on dock menu closes (GoodWine X)
      if (details.classList.contains('menu-open') || details.hasAttribute('open')) {
        closeMenu();
        return;
      }

      details.setAttribute('open', '');
      details.classList.add('menu-open');
      document.body.classList.add('wd-gw-menu-open');

      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');

      if (drawer && typeof drawer.open === 'function') {
        try {
          drawer.open();
        } catch (err) {}
      }

      var panel = details.querySelector(':scope > .menu-drawer');
      if (panel) {
        panel.style.pointerEvents = 'auto';
        panel.style.zIndex = '100';
      }
    }

    function openSearch() {
      var modal = document.querySelector('#search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
        return;
      }
      var trigger = document.querySelector('.search-action button, search-button button');
      if (trigger) trigger.click();
      else window.location.href = wdStoreUrl('search');
    }

    function openCart() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return;
      }
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }
      window.location.href = wdStoreUrl('cart');
    }

    function openAccount() {
      /* Always use themed cabinet on mobile — Shopify hosted account.winedepo.uz cannot be styled */
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        window.location.assign(wdStoreUrl('pages/loyalty'));
        return;
      }
      var drawer = document.querySelector('dialog-component.account-drawer');
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return;
      }
      var trigger = document.querySelector(
        '.account-drawer .account-button, .account-drawer > button, dialog-component.account-drawer button[aria-haspopup]'
      );
      if (trigger) {
        trigger.click();
        return;
      }
      window.location.assign(wdStoreUrl('pages/loyalty'));
    }

    function openCitySheet() {
      var sheet = document.querySelector('[data-wd-city-sheet]');
      if (!sheet) return;
      sheet.hidden = false;
      sheet.classList.add('is-open');
    }

    function closeCitySheet() {
      var sheet = document.querySelector('[data-wd-city-sheet]');
      if (!sheet) return;
      sheet.classList.remove('is-open');
      sheet.hidden = true;
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-wd-menu-close]')) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
        return;
      }

      var dockBtn = e.target.closest('[data-wd-dock]');
      if (dockBtn) {
        e.preventDefault();
        var action = dockBtn.getAttribute('data-wd-dock');
        if (action === 'menu') openMenu();
        else if (action === 'search') openSearch();
        else if (action === 'cart') openCart();
        else if (action === 'account') {
          if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
            window.location.assign(wdStoreUrl('pages/loyalty'));
          } else {
            openAccount();
          }
        }
        return;
      }

      if (e.target.closest('[data-wd-city-open]')) {
        e.preventDefault();
        openCitySheet();
        return;
      }

      if (e.target.closest('[data-wd-city-close]')) {
        e.preventDefault();
        closeCitySheet();
        return;
      }

      var sheet = e.target.closest('[data-wd-city-sheet]');
      if (sheet && e.target === sheet) closeCitySheet();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCitySheet();
        if (document.body.classList.contains('wd-gw-menu-open')) closeMenu();
      }
    });

    // Keep dock X in sync if drawer closes elsewhere
    document.addEventListener(
      'toggle',
      function (e) {
        var details = e.target;
        if (!details || details.id !== 'Details-menu-drawer-container') return;
        if (details.open || details.classList.contains('menu-open')) {
          document.body.classList.add('wd-gw-menu-open');
        } else {
          document.body.classList.remove('wd-gw-menu-open');
        }
      },
      true
    );
  }

  function initPdpBurst() {
    /* CSS :hover plus JS class — Windows Chrome often reports pointer: coarse
       and would otherwise hide the bottle burst entirely. */
    document.querySelectorAll('[data-wd-pdp-stage]').forEach(function (stage) {
      if (stage.__wdBurst) return;
      stage.__wdBurst = true;
      function desktop() {
        return window.matchMedia('(min-width: 750px)').matches;
      }
      stage.addEventListener('pointerenter', function (e) {
        if (!desktop()) return;
        if (e.pointerType === 'touch') return;
        stage.classList.add('is-burst');
      });
      stage.addEventListener('pointerleave', function () {
        stage.classList.remove('is-burst');
      });
    });
  }

  function initPdpQty() {
    document.querySelectorAll('[data-wd-pdp-qty]').forEach(function (wrap) {
      if (wrap.__wdQty) return;
      wrap.__wdQty = true;
      var input = wrap.querySelector('.wd-pdp-buybox__qty-input');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wd-qty]');
        if (!btn) return;
        e.preventDefault();
        var delta = parseInt(btn.getAttribute('data-wd-qty'), 10) || 0;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = String(next);
      });
    });
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (item) {
      if (item && item.dataset && item.dataset.sectionId) ids.push(item.dataset.sectionId);
    });
    return ids;
  }

  function cartAddUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) {
      return window.Theme.routes.cart_add_url;
    }
    return wdRoutesRoot() + 'cart/add.js';
  }

  function dispatchCartUpdate(resource, sections, itemCount) {
    var line = resource || {};
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: line,
          sourceId: 'wd-product-card',
          data: {
            source: 'wd-product-card',
            itemCount: typeof itemCount === 'number' ? itemCount : 1,
            sections: sections || {},
            variantId: line.variant_id || line.id || undefined,
            productId: line.product_id || undefined,
          },
        },
      })
    );
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;
    if (typeof cartDrawer.open === 'function') cartDrawer.open();
    else if (typeof cartDrawer.showDialog === 'function') cartDrawer.showDialog();
  }

  function setPlusState(button, state) {
    button.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) button.classList.add(state);
    button.setAttribute('aria-busy', state === 'is-loading' ? 'true' : 'false');
  }

  function cardAddErrorMessage() {
    return (
      (window.WDStrings && window.WDStrings.cardAddError) ||
      'Не удалось добавить в корзину'
    );
  }

  function initCardAddToCart() {
    if (document.documentElement.__wdCardAtc) return;
    document.documentElement.__wdCardAtc = true;

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('button[data-wd-add-to-cart]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();

        var variantId = button.getAttribute('data-variant-id');
        if (!variantId || button.disabled) return;

        var sections = cartSectionIds();
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        if (sections.length) formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);

        button.disabled = true;
        setPlusState(button, 'is-loading');

        fetch(cartAddUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          },
          body: formData,
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || data.status) {
                throw new Error(
                  (data && (data.description || data.message)) ||
                    cardAddErrorMessage()
                );
              }
              return data;
            });
          })
          .then(function (data) {
            dispatchCartUpdate(data, data.sections, 1);
            setPlusState(button, 'is-added');
            setTimeout(function () {
              setPlusState(button, '');
              button.disabled = false;
            }, 1100);
          })
          .catch(function (err) {
            console.warn('[wd-card-atc]', err);
            setPlusState(button, 'is-error');
            button.setAttribute(
              'title',
              (err && err.message) || cardAddErrorMessage()
            );
            setTimeout(function () {
              setPlusState(button, '');
              button.removeAttribute('title');
              button.disabled = false;
            }, 1600);
          });
      },
      true
    );
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    initCarousels(event.target);
    initCurationTabs(event.target);
    initReveal(event.target);
    initDateParallax(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initCarousels();
      initCurationTabs();
      initReveal();
      initCatalogFilters();
      initWdQuickFilters();
      initMobileDock();
      initPdpBurst();
      initPdpQty();
      initCardAddToCart();
      initDateParallax();
    });
  } else {
    init();
    initCarousels();
    initCurationTabs();
    initReveal();
    initCatalogFilters();
    initWdQuickFilters();
    initMobileDock();
    initPdpBurst();
    initPdpQty();
    initCardAddToCart();
    initDateParallax();
  }
})();
